import { mapMutations } from 'vuex'
import helpers from '../helpers'

export const resourceControl = {
  data () {
    return {
      loading: false,
      dataLoading: false,
      activeId: null,
      labels: {
        name: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 0),
        create: this.$t('labels.action_resource', { action: this.$t('labels.create'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        edit: this.$t('labels.action_resource', { action: this.$t('labels.edit'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        delete: this.$t('labels.action_resource', { action: this.$t('labels.delete'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        send: this.$t('labels.action_resource', { action: this.$t('labels.send'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        view: this.$t('labels.action_resource', { action: this.$t('labels.view'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        assign: this.$t('labels.action_resource', { action: this.$t('labels.assign'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        download: this.$t('labels.action_resource', { action: this.$t('labels.download'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        upload: this.$t('labels.action_resource', { action: this.$t('labels.upload'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        email: this.$t('labels.action_resource', { action: this.$t('labels.email'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) }),
        text: this.$t('labels.action_resource', { action: this.$t('labels.text'), resource: this.$tc('labels.' + helpers.camelToSnake(helpers.singular(this.$options.name)), 1) })
      }
    }
  },
  computed: {
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    },
    config () {
      const config = { icon: this.icon }
      if (this.view === 'single') config.object = this.$options.name
      else config.collection = this.$options.name
      if (this.activeId) config.id = this.activeId
      if (this.apiTarget) {
        Object.assign(config, {
          path: this.apiTarget[0],
          id: this.apiTarget[1],
          tag: this.apiTarget[2]
        })
        if (this.activeId) config.tag_id = this.activeId
      }
      return config
    }
  },
  mounted () {
    if (this.view === 'silent') {
      // Do nothing
    } else if (this.view === 'single') this.show()
    else this.index(this.page)
  },
  methods: {
    ...mapMutations([
      'pushState',
      'pushFilter'
    ]),
    find (objects, match, value, key) {
      return helpers.find(objects, match, value, key)
    },
    applySort (val) {
      this.pushState({ view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    handleState (page, count, filters) {
      if (page) this.pushState({ view: this.$options.name, key: 'page', data: page })
      if (count) this.pushState({ view: this.$options.name, key: 'tableRows', data: count })
      if (filters) this.pushFilter({ view: this.$options.name, data: filters })
    },
    show () {
      this.loading = true
      this.$store.dispatch('show', this.config).then(() => { this.loading = false })
    },
    index (page, count, filters) {
      this.handleState(page, count, filters)
      this.loading = true
      this.$store.dispatch('index', this.config).then(() => { this.loading = false })
    },
    beforeCreate () {},
    create () {
      this.beforeCreate()
      this.$store.commit('axiosError', null)
      helpers.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
      this.afterCreate()
    },
    afterCreate () {},
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.$store.commit('axiosError', null)
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    beforeSubmit () {},
    submit () {
      this.beforeSubmit()
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { ...this.config, resource: this.resource }).then((res) => {
        this.$modal.hide('create-' + this.$options.name)
        this.afterSubmit(res)
      })
    },
    afterSubmit (res) {},
    destruction () {
      this.$store.dispatch('destroy', this.config).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
        this.activeId = null
      })
    }
  }
}
